import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../assets/css/header.css";
// You might need an icon package for search and cart, using simple SVG here for now

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    setOpenDropdown(null);
  };

  const toggleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };

  return (
    <header className={`modern-header ${isScrolled ? "header-scrolled" : ""}`}>
      <div className="header-container">
        <div className="header-content">
          {/* Logo */}
          <Link to="/" className="header-logo">
            <img src={require('../assets/images/edu-logo.jpeg')} alt="The Study Home Tutorial Logo" className="logo-image" />
          </Link>

          {/* Desktop Navigation */}
          <nav className="desktop-nav">
            <ul className="nav-menu">
              <li className="nav-item">
                <Link to="/" className="nav-link">Home</Link>
              </li>
              <li className="nav-item">
                <Link to="/shop" className="nav-link">About</Link>
              </li>
              <li className="nav-item">
                <Link to="/brands" className="nav-link">Services</Link>
              </li>
              <li className="nav-item">
                <Link to="/about" className="nav-link">Class</Link>
              </li>

              <li className="nav-item">
                <Link to="/about" className="nav-link">Contact</Link>
              </li>
            </ul>
          </nav>



          {/* Mobile Menu Toggle */}
          <button
            className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </button>
        </div>

        {/* Mobile Navigation */}
        <div className={`mobile-nav ${isMobileMenuOpen ? 'active' : ''}`}>
          <ul className="mobile-menu">
            <li className="mobile-nav-item">
              <Link to="/" className="mobile-nav-link" onClick={toggleMobileMenu}>Home</Link>
            </li>

            <li className="mobile-nav-item">
              <Link to="/about" className="mobile-nav-link" onClick={toggleMobileMenu}>About</Link>
            </li>

            <li className="mobile-nav-item">
              <Link to="/services" className="mobile-nav-link" onClick={toggleMobileMenu}>Services</Link>
            </li>

            <li className="mobile-nav-item">
              <Link to="/class" className="mobile-nav-link" onClick={toggleMobileMenu}>Class</Link>
            </li>

            <li className="mobile-nav-item">
              <Link to="/contact" className="mobile-nav-link" onClick={toggleMobileMenu}>Contact</Link>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
}

export default Header;
